import { createContext } from "react";
import Sale from "../../../../utilities/data/model/Sale";

export interface SaleControllerContextType {
  sale?: Sale;
  createEmptySale(): Promise<Sale>;
}

export const SaleControllerContext = createContext<
  SaleControllerContextType | undefined
>(undefined);
